import React, { FC, memo, useState } from 'react';
import CustomFilterModal from 'Component/pages/components/custom-filter-modal';
import CustomFilterEdit from 'Component/pages/components/custom-filter-edit';
import styled from 'styled-components';

const Wrapper = styled.div``;

interface TemplateProps {
    value?: {
        conditionList?: any;
        customJudgeLogic?: any;
        judgeStrategy?: any;
    };
    onChange?: (value: TemplateProps['value']) => void;
    type: number;
    querryType?: string;
    filterList?: string[];
}

const Template: FC<TemplateProps> = memo((props) => {
    const { onChange, type, querryType, filterList } = props;

    const [filterVisible, setFilterVisible] = useState(false);
    const [customId, setCustomId] = useState<number>();
    const [customName] = useState('');

    const onCancel = () => {
        setFilterVisible(false);
    };

    const handleConditionApply = (conditionList, customJudgeLogic, judgeStrategy, id, name) => {
        onChange?.({
            conditionList,
            customJudgeLogic,
            judgeStrategy,
        });
        onCancel();
    };

    const onConditionFilterSaved = (flag, data) => {
        if (data) {
            setCustomId(data.id);
        }
    };

    return (
        <Wrapper>
            <CustomFilterModal
                visible={filterVisible}
                cancel={onCancel}
                applyAction={handleConditionApply}
                onConditionFilterSaved={onConditionFilterSaved}
                judgeStrategy={props.value?.judgeStrategy ?? 1}
                customJudgeLogic={props.value?.customJudgeLogic}
                customName={customName}
                customId={customId}
                conditionList={props.value?.conditionList ?? []}
                type={type}
                querryType={querryType ?? 'empty'}
                filterList={filterList ?? ['empty']}
                filterTaskData={true}
                isAutoHideOperator={true}
            />
            <CustomFilterEdit
                cusBtnProps={{ type: 'default', icon: null }}
                onClick={() => setFilterVisible(true)}
                {...props.value}
            />
        </Wrapper>
    );
});

export default Template;
